import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import EyeIcon from "@material-ui/icons/RemoveRedEye";
import TablePagination from "@material-ui/core/TablePagination";
import { Badge } from "react-bootstrap";
import { FaRegCreditCard, FaFingerprint } from 'react-icons/fa';
import { TbDeviceNintendo } from "react-icons/tb"

import { useSelector } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
  Tooltip,
  CircularProgress,
} from "@material-ui/core";

const headRows = [

  {
    id: "fullName",
    numeric: false,
    disablePadding: false,
    label: "A.S.A",
  },
  {
    id: "id",
    numeric: false,
    disablePadding: false,
    label: "Fin kod ",
  },
  {
    id: "duty",
    numeric: false,
    disablePadding: false,
    label: "Vəzifə ",
  },

  {
    id: "fingerprint",
    numeric: false,
    disablePadding: false,
    label: "Barmaq sayı",
  },
  {
    id: "cardLimit",
    numeric: false,
    disablePadding: false,
    label: "Kart sayı",
  },
  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "Vəziyyət",
  },

  {
    id: "tools",
    numeric: false,
    disablePadding: true,
    label: "Əməliyyatlar",
  },
];

function EnhancedTableHead(props) {
  const {
    order,
    orderBy,
    onRequestSort,

  } = props;

  return (
    <TableHead>
      <TableRow>

        {headRows.map((row) => (
          <TableCell
            key={row.id}
            align={row.numeric ? "right" : "left"}
            sortDirection={orderBy === row.id ? false : false}
            className="employeeReport"
          >
            <TableSortLabel active={orderBy === row.id}
              direction={order ? "asc" : "desc"}
              onClick={() => {
                return row.id !== "tools" && row.id !== "fullName" && row.id !== "status" ? onRequestSort(row.id) : null;
              }} 
              >
              {row.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto"
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#072C8C",
  },
}));

export default function EnhancedTable({
  saps,
  isLoading,
  setChooseSapId,
  setOpenView,
  deleteSapsIds,
  setDeleteSapsIds,
  setSortField,
  setOrderByTable,
  sortField,
  orderBy,
  updateSkip,
  updateTake,
  count,
  isError,
  setShowLog,
  setShowFingerLog,
  setShowDeviceLog
}) {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const permissionList = useSelector(state => state.auth.permissionList)

  function handleRequestSort(property) {
    const isDesc = sortField === property && orderBy === 'desc';
    setOrderByTable(isDesc ? 'asc' : 'desc');
    setSortField(property);
    updateTake(10);
    setRowsPerPage(10);
    updateSkip(0);
    setPage(0);
  }

  function handleSelectAllClick(event) {
    if (event.target.checked) {
      const newSelecteds = saps.map((n) => n.id);
      setDeleteSapsIds(newSelecteds);
      return;
    }
    setDeleteSapsIds([]);
  }



  function handleChangePage(event, newPage) {
    setPage(newPage);
    updateSkip(newPage);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value);
    updateTake(+event.target.value);
    setPage(0);
    updateSkip(0);
  }

  const isSelected = (id) => deleteSapsIds.indexOf(id) !== -1;

  return (
    <div className={`${classes.root} overflowDesign`}>
      <Paper className={classes.paper}>
        {isLoading && (
          <div className={classes.progresRoot}>
            <CircularProgress className={classes.progress} />
          </div>
        )}

        <div className={classes.tableWrapper}>
          {saps.length ? (
            
            <Table className={classes.table} aria-labelledby="tableTitle">
              <EnhancedTableHead
                numSelected={deleteSapsIds.length}
                onSelectAllClick={handleSelectAllClick}
                rowCount={saps.length}
                order={orderBy}
                orderBy={sortField}
                onRequestSort={handleRequestSort}

              />
            
              <TableBody>
                {saps.map((row, index) => {
                  const isItemSelected = isSelected(row.id);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={index}
                      selected={isItemSelected}
                    >

                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.fullName}
                      </TableCell>

                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.pin}
                      </TableCell>

                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.duty}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.fingerCount}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.cardCount}
                      </TableCell>

                      <TableCell padding="default" className="pr-4 px-4">
                        <Badge
                          variant={
                            row.status === "INACTIVE"
                              ? "info"
                              : row.status === "ACTIVE" ? "success" : "-"
                          }
                        >
                          {row.status === "INACTIVE"
                            ? "Deaktiv"
                            : row.status === "ACTIVE" &&
                            "Aktiv"}
                        </Badge>
                      </TableCell>

                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        <Tooltip title="Göstər" placement="top">
                          <button
                            aria-label="view"
                            className="btn btn-sm btn-icon btn-bg-light btn-text-info btn-hover-info mr-2"
                            onClick={() => {
                              setChooseSapId(row.pin);
                              setOpenView();
                            }}
                          >
                            <EyeIcon />
                          </button>
                        </Tooltip>
                        {permissionList.some(element => element === "view_employee_card_log") &&

                          <Tooltip title="Kart" placement="top">
                            <button
                              aria-label="kart"
                              className={`btn btn-sm btn-icon btn-bg-light  btn-text-warning btn-hover-warning mr-2`}

                              onClick={() => {
                                setChooseSapId(row.pin);
                                setShowLog(true);
                              }}

                            >
                              <FaRegCreditCard style={{ fontSize: "18px" }} />
                            </button>
                          </Tooltip>}
                        {permissionList.some(element => element === "view_employee_fingerprint_log") &&
                          <Tooltip title="Barmaq izi" placement="top">
                            <button
                              aria-label="Finger"
                              className={`btn btn-sm btn-icon btn-bg-light  btn-text-dark btn-hover-dark mr-2`}

                              onClick={() => {
                                setChooseSapId(row.pin);
                                setShowFingerLog(true);
                              }}

                            >
                              <FaFingerprint style={{ fontSize: "18px" }} />
                            </button>
                          </Tooltip>
                        }
                        {permissionList.some(element => element === "view_employee_device_log") &&
                          <Tooltip title="Qurğu" placement="top">
                            <button
                              aria-label="kart"
                              className={`btn btn-sm btn-icon btn-bg-light  btn-text-success btn-hover-success mr-2`}

                              onClick={() => {
                                setChooseSapId(row.pin);
                                setShowDeviceLog(true);
                              }}

                            >
                              <TbDeviceNintendo style={{ fontSize: "18px" }} />
                            </button>
                          </Tooltip>}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          ) :!saps.length && !isLoading && !isError ? (
            <div className="noInfo">
              <img
                src="/media/error/search.png"
                className="info-img"
                alt="information"
              />
              <h4>İnformasiya tapılmadı</h4>
            </div>
          ) : (
            !isLoading &&
            isError && (
              <div className="noInfo">
                <img
                  src="/media/error/connect.png"
                  className="info-img"
                  alt="connection"
                />
                <h4>Bağlantı yoxdur</h4>
              </div>
            )
          )}

        </div>
        {count > 10 && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={count}
            labelRowsPerPage={"Sətirlərin sayı"}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              "aria-label": "Əvvəlki səhifə",
            }}
            nextIconButtonProps={{
              "aria-label": "Növbəti səhifə",
            }}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />)}
      </Paper>
    </div>
  );
}
